export default "__VITE_ASSET__BWQjjKZ9__"